import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04f7dd45&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=04f7dd45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f7dd45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f7dd45')) {
      api.createRecord('04f7dd45', component.options)
    } else {
      api.reload('04f7dd45', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=04f7dd45&scoped=true&", function () {
      api.rerender('04f7dd45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/hqDrawer/index.vue"
export default component.exports